// extracted by mini-css-extract-plugin
module.exports = {"formInput":"phone-input_formInput__j88_J","formLabel":"phone-input_formLabel__1l4D8 mb-0","formError":"phone-input_formError__2Y8vO"};